if ( typeof NutritionalInfo !== 'function' ) {

    class NutritionalInfo extends HTMLElement {
      constructor() {
        super();
        let contentDOM = ``;
        let content = this.innerHTML;
        let titleFlag = false;
        content = content.replace(/<\/p>|<\/div>/g, '');
        content = content.split('<p>');
        for ( let i = 1; i < content.length; i++ ) {
          let contentArray = content[i].split(/<br>|<br\/>|\n/g);
  
          contentDOM += `<div class="table">`
  
          if ( this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '' ) {
            if ( !titleFlag ) {
              titleFlag = true;
              contentDOM += `<span class="table-line table-line--heading">`;
              if ( this.dataset.titleLabelLeft != '' ) {
                contentDOM += `<span>${this.dataset.titleLabelLeft}</span>`;
              }
              if ( this.dataset.titleLabelRight != '' ) {
                contentDOM += `<span>${this.dataset.titleLabelRight}</span>`;
              }
              contentDOM += `</span>`;
            }
          }
  
          for ( let j = 0; j < contentArray.length; j++ ) {
            if (contentArray[j].length > 0 && contentArray[j].replace(/\s/g, '').length != 0 ) {
              let contentBlockArrayPrepare = contentArray[j].replace(/,/g, '#SD*@N!SA')
              let contentBlockArray = contentBlockArrayPrepare.split('#SD*@N!SA');
              let values = [];
              for ( let k = 0; k < contentBlockArray.length; k++ ) {
                let trimmedValue = contentBlockArray[k].trim();
              
                values.push(trimmedValue.replace('-', ''));
              }
              
                           let lineClass = contentArray[j].includes('-') ? 'table-line--indent' : '';
              if ( values.length === 3 ) {
                lineClass += (lineClass ? ' ' : '') + 'table-line--three-cols';
              } else if ( values.length === 2 ) {
                lineClass += (lineClass ? ' ' : '') + 'table-line--two-cols';
              }
              
              contentDOM += `<span class="table-line ${lineClass}">`;
              for ( let k = 0; k < values.length; k++ ) {
                contentDOM += `<span>${values[k]}</span>`
              }
              contentDOM += `</span>`;
            }
          }
  
          contentDOM += `</div>`;
  
        }
        
        this.innerHTML = contentDOM;
  
      }
    }
  
    if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
      customElements.define('nutritional-info', NutritionalInfo);
      
      if ( !document.getElementById('nutritional-info-styles') ) {
        const style = document.createElement('style');
        style.id = 'nutritional-info-styles';
        style.textContent = `
          .table-line {
            display: flex;
            width: 100%;
          }
          
          .table-line > span {
            flex: 1;
          }
          
          .table-line--two-cols > span:first-child {
            flex: 1;
            text-align: left;
          }
          
          .table-line--two-cols > span:last-child {
            flex: 1;
            text-align: right;
          }
          
          .table-line--three-cols > span:nth-child(1) {
            flex: 1;
            text-align: left;
          }
          
          .table-line--three-cols > span:nth-child(2) {
            flex: 1;
            text-align: center;
          }
          
          .table-line--three-cols > span:nth-child(3) {
            flex: 0 0 auto;
            min-width: 60px;
            max-width: 80px;
            text-align: right;
          }
        `;
        document.head.appendChild(style);
      }
      }
  
  }
  